/**
 * @generated SignedSource<<4b50698938b2ddf536cf60557a69e320>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

import ContractPractitionersTableRefetch_graphql from './ContractPractitionersTableRefetch.graphql';

var node = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "firstName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "lastName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "legalContractId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "locationName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "npi"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tin"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": ContractPractitionersTableRefetch_graphql
    }
  },
  "name": "ContractPractitionersTableFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "firstName",
              "variableName": "firstName"
            },
            {
              "kind": "Variable",
              "name": "lastName",
              "variableName": "lastName"
            },
            {
              "kind": "Variable",
              "name": "legalContractId",
              "variableName": "legalContractId"
            },
            {
              "kind": "Variable",
              "name": "locationName",
              "variableName": "locationName"
            },
            {
              "kind": "Variable",
              "name": "npi",
              "variableName": "npi"
            },
            {
              "kind": "Variable",
              "name": "tIN",
              "variableName": "tin"
            }
          ],
          "kind": "ObjectValue",
          "name": "input"
        }
      ],
      "concreteType": "Practitioner",
      "kind": "LinkedField",
      "name": "filteredPractitioners",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PractitionerIdentifier",
          "kind": "LinkedField",
          "name": "identifiers",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentifierType",
              "kind": "LinkedField",
              "name": "identifierType",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PractitionerVersion",
          "kind": "LinkedField",
          "name": "applicableVersion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

node.hash = "6c021df76268d3354ed199066abdbebb";

export default node;
